import type { MakeTransferBody } from 'api/v2/transactions/makeTransfer';
import makeTransfer from 'api/v2/transactions/makeTransfer';
import useMutation from 'hooks/react-query/useMutation';

import type { Transaction } from 'types/transactions.types';
import { appendQP } from 'utils/helpers';

const useMakeTransfer = ({
  withRedirection,
  onTransferSuccess,
  redirectionParams,
  redirectionPath,
}: {
  withRedirection?: boolean;
  onTransferSuccess?: (transaction?: Transaction) => void;
  redirectionParams?: Record<string, any>;
  redirectionPath?: string;
}) => {
  return useMutation(
    (
      body: Omit<MakeTransferBody, 'successRedirectUri' | 'errorRedirectUri'>,
    ) => {
      // Determine if this is a scheduled payment by checking the body
      // - requestedExecutionAt: scheduled transfer (OneTime + future)
      // - period: standing order (Daily, Weekly, Monthly)
      const isScheduledPayment = !!(body.requestedExecutionAt || body.period);

      return makeTransfer({
        ...body,
        successRedirectUri: `${window.location.origin}${
          redirectionPath || window.location.pathname
        }?${appendQP(window.location.search, {
          successfulPayment: 'true',
          ...(isScheduledPayment && { isScheduledPayment: 'true' }),
          ...redirectionParams,
        })}`,
        errorRedirectUri: `${window.location.origin}${window.location.pathname}?error=true`,
      });
    },
    {
      onSuccess: ({ redirectUri }) => {
        onTransferSuccess?.();

        if (withRedirection) {
          window.location.href = redirectUri;
        }
      },
    },
  );
};

export default useMakeTransfer;
